export default __webpack_public_path__ + "images/tap-hero.1aedcd2048127c9dc7d4c38d11442abb.png";